import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { BinScatterCrossSelectResult } from 'libs/end-to-end/src/bin-scatter';

export const BinScatterCrossSelectCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'binScatterCrossSelect',
  isDataQueuingAllowed: true,
  outputFileName: 'binscatter_cross_select_result.json',
  outputSchema: BinScatterCrossSelectResult,
  resolveFocusArea: (request) => {
    if (request.customVizId !== 'binScatterCrossSelect') {
      throw new Error('Invalid custom viz ID');
    }
    return request.inputs.extras.focusArea;
  },
  resolveFilters: () => null,
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: false,
  complexityParams: {
    aValue: 0.443,
    multiplier: 0.0692,
  },
  eventProperties: (request) => {
    if (request.customVizId !== 'binScatterCrossSelect') {
      throw new Error('Invalid custom viz ID');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: [
        request.inputs.extras.group1.dimension1,
        request.inputs.extras.group1.dimension2,
        request.inputs.extras.group2.dimension1,
        request.inputs.extras.group2.dimension2,
      ],
      'Selected Dimensions': [request.inputs.extras.dimension],
      'Selected Metrics': [request.inputs.extras.metric],
      'Selected Focus Areas': [request.inputs.extras.focusArea],
    };
  },
  getUrlPath: (focusArea) => `${focusArea}/group-trends`,
};
